import CTA from "@/components/sections/CTA";
import FAQ from "@/components/sections/FAQ";
import ServicesAbout from "@/components/sections/ServicesAbout";
import ServicesCTA from "@/components/sections/ServicesCTA";
import ServicesDeadline from "@/components/sections/ServicesDeadline";
import ServicesHero from "@/components/sections/ServicesHero";
import ServicesHWW from "@/components/sections/ServicesHWW";
import ServicesInfo from "@/components/sections/ServicesInfo";
import ServicesPricing from "@/components/sections/ServicesPricing";
import ServicesProjects from "@/components/sections/ServicesProjects";
import cmsClient from "@/lib/cmsClient";
import Clients from "@/components/sections/Clients";
import gsap from "gsap";
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Head from "next/head";
import ServicesRest from "../../components/sections/ServicesRest";
import WrapperBg from "../../components/layout/WrapperBg";
import BGColorChangeWrapper from "../../components/layout/BGColorChangeWrapper";
import ScrollToTopChecker from "../../components/layout/ScrollToTopChecker";
import Header from "@/components/layout/Header";
import FormPOPUP from "@/components/ui/FormPOPUP";
import Footer from "@/components/layout/Footer";


 gsap.registerPlugin(ScrollTrigger);


export async function getStaticProps({ locale }) {
  try {
    const [data, globalData] = await Promise.all([
      cmsClient("page/services", {}, { service: "ofices" , lang: locale }),
      cmsClient("general", {}, { lang: locale }),
    ]);

    return {
      props: {
        data,
        globalData,
      },
    };
  } catch (error) {
    return {
      props: {
        data: null,
        globalData: null,
      },
    };
  }
}

export default function Ofisy({data, globalData}) {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

  const acf = data.acf

  const contacts = globalData.header?.menu?.find(
      item => item.text === 'Contacts'
  );

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Designic",
        "url": "https://designic.com",
        "email": "info@designic.com",
        "telephone": "+7 921 915 60 83",
        "logo": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg",
        "image": "https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Малый проспект П.С., д. 5 литер Б, офис 404",
          "addressLocality": "Санкт-Петербург, Россия",
          "postalCode": "197198",
          "addressCountry" : "RU"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "ГЛАВНАЯ",
            "item": "https://designic.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "УСЛУГИ",
            "item": "https://designic.com/uslugi/"
          }
        ]
      }
    ]
  };


  return (
    <>
      <Head>
        <title>{data.seo.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" key={'viewport-custom'}/>
        <meta charSet="UTF-8"/>
	      <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
        <link rel="profile" href="https://gmpg.org/xfn/11"></link>
        {/* <meta name="robots" content="noindex, nofollow" /> */}
        <meta name="description" content={data.seo.description}/>
        <meta name="robots" content="max-image-preview:large"/>
        <link rel="canonical" href={`${baseUrl}/uslugi/ofisy-i-delovye-prostranstva/`}/>
        <meta property="og:locale" content="ru_RU"/>
        <meta property="og:site_name" content={data.seo.og.site_name}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={data.seo.og.title}/>
        <meta property="og:description" content={data.seo.og.description}/>
        <meta property="og:url" content="https://designic.com/"/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={data.seo.title}/>
        <meta name="twitter:description" content={data.seo.description}></meta>

        <link rel="alternate" hrefLang="ru" href={`${baseUrl}/uslugi/ofisy-i-delovye-prostranstva/`}/>
        <link rel="alternate" hrefLang="en" href={`${baseUrl}/en/uslugi/ofisy-i-delovye-prostranstva/`}/>
        <link rel="alternate" hrefLang="x-default" href={baseUrl}/>

        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-32x32.jpg" sizes="32x32"/>
        <link rel="icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-192x192.jpg" sizes="192x192"/>
        <link rel="apple-touch-icon" href="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-180x180.jpg"/>
        <meta name="msapplication-TileImage" content="https://designic.com/wp-content/uploads/2023/07/cropped-fav-2-270x270.jpg"></meta>
        <script
          type="application/ld+json"
          className="aioseo-schema"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <Header headerData={globalData.header}/>
      <FormPOPUP title={data?.cta_title} formInfo={globalData.form} formResponse={globalData?.['form-response']}/>
      <ScrollToTopChecker/>
      <WrapperBg>
        <BGColorChangeWrapper colorClass={'bg-beige'}>
          <ServicesHero pageTitle={acf?.hero_title} text={acf?.hero_text} image={acf?.hero_image} serviceTitle={acf?.hero_subtitle} breadcrumbsTitle={data.title}/>
          <ServicesInfo title={acf?.design_space_title} image={acf?.design_space_image} text={acf?.design_space_text} list={acf?.design_space_list} aftertext={acf?.design_space_aftertext} />
          <ServicesHWW title={acf?.how_its_work_title} text={acf?.how_its_work_text} aftertext={acf?.how_its_work_aftertext} items={acf?.how_its_work_list}/>
          <ServicesPricing title={acf?.pricing_title} items={acf?.pricing_list} cta_text={acf?.pricing_cta.text} cta_button={acf?.pricing_cta.btn_text} desc={acf?.pricing_desc} lang={globalData?.language} menu={contacts}/>
          <ServicesDeadline title={acf?.timing_title} list={acf?.timing_list}/>
          <ServicesProjects btn_text={acf?.portfolio_btn_text} btn_item_text={acf?.portfolio_item_btn_text} buttonLink={'/proekty/ofisy-i-kovorkingi/'} title={acf?.portfolio_title} text={acf?.portfolio_text} items={acf?.portfolio_items}/>
          {acf?.clients_status ?  <Clients textColorClassName={'text-dusty-green-dark'} bgColorClassName={'bg-beige'} clients_items={acf.clients_items} title={acf.clients_title} text={acf.clients_subtitle}/> : null}
          <ServicesCTA title={acf?.cta_title} desc={acf?.cta_desc} image={acf?.cta_image} btn_text={acf.cta_btn_text} lang={globalData?.language} menu={contacts}/>
          <ServicesAbout image={acf?.services_seo_image} text={acf?.services_seo_text} title={acf?.services_seo_title}/>
          <FAQ title={acf?.faq_title} items={acf?.faq_itmes}/>
          <ServicesRest btn_text={acf?.services_item_btn_text} title={acf?.services_title} text={acf?.text} items={acf?.services_all}/>
        </BGColorChangeWrapper>
        <BGColorChangeWrapper colorClass={'bg-sky-blue'}>
          {globalData?.language !== 'en' && (
              <CTA title={data.cta_title} image={data.cta_image} formInfo={globalData.form} formResponse={globalData['form-response']} isBottomSectionNeed={false}/>
          )}
        </BGColorChangeWrapper>
      </WrapperBg>
      <Footer footerData={globalData.footer} social={globalData.socials} />
    </>
  )
}